/**
 * this is used for the zod form builder when wanting to render fields o type object
 * fields of type object must be mapped here to render the correct input type
 */
export enum ZodFormObjectTypeDescription {
  ZOD_FILE = "ZodFile",
  ZOD_STYLING_CLASS = "StylingClass",
  ZOD_CSS_VARIABLE = "CssVariable",
}
